import { Coupon } from './Coupon'

export enum PaymentTypeEnum {
  Shipments = 'Shipments',
  Coupon = 'Coupon',
  Giftcard = 'Giftcard',
}
export interface AffPayment {
  type: PaymentTypeEnum
  date: string
  payment: string
}

export interface AffUser {
  rev: number
  pkgIncomeOffset: number
  couponIncomeOffset: number
  isOnHold?: boolean
  boughtPackages: number
  registeredUsers: number
  createdAt: string
  email: string
  paymentGiftCards: number
  paymentsHistory: AffPayment[]
  updatedAt: string
  packagesShipmentIncome: number
  refFullName: string
  refNum: string
  id: string
  refUserId: string
}

export interface AffUserData extends AffUser {
  coupons: Coupon[]
  pkgIncome: number
}
